import * as AccommodationService from '~/services/AccommodationService';

import { CatalogItemConfig } from '../types/catalogItem';

export const inclusionConfig: CatalogItemConfig<
  AccommodationService.AdminInclusion,
  AccommodationService.InclusionUpdatePayload,
  AccommodationService.InclusionCreatePayload,
  AccommodationService.ApproveInclusionPayload,
  AccommodationService.MergeInclusionPayload
> = {
  // Service methods
  listItems: async (params) => {
    const response = await AccommodationService.listInclusions({
      ...params,
      status: params.status ?? 'approved',
    });
    return {
      ...response,
      result: {
        items: response.result.inclusions,
        total: response.result.total,
      },
    };
  },
  updateItem: AccommodationService.updateInclusion,
  createItem: AccommodationService.createInclusion,
  deleteItem: AccommodationService.deleteInclusion,
  approveItem: AccommodationService.approveInclusion,
  discardItem: AccommodationService.discardInclusion,
  mergeItem: AccommodationService.mergeInclusion,
  createMergePayload: (sourceCode, targetCode) => ({
    sourceInclusionCode: sourceCode,
    targetInclusionCode: targetCode,
  }),

  // Query keys
  queryKeyPrefix: 'inclusions',

  // Labels
  itemName: 'Inclusion',
  itemNamePlural: 'Inclusions',

  // Type
  type: 'inclusion',
};
